var render = function render(_c,_vm){return _c(_vm.props.to ? 'router-link' : 'div',_vm._g({key:_vm.data.key,tag:"component",staticClass:"list__item",class:{
    'list__item--active': _vm.props.value,
    'list__item--active-exact': _vm.props.exact,
    'list__item--clickable': !!_vm.listeners.click || _vm.props.to,
    'list__item--hoverable': !!(_vm.listeners.click || _vm.props.to || _vm.props.hoverable),
  },attrs:{"role":"listitem","to":_vm.props.to}},_vm.listeners),[_vm._t("avatar"),_c('div',{staticClass:"list__item__content"},[_vm._t("default")],2),_vm._t("action")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }